import PropTypes from "prop-types"
import React, { useEffect, useRef ,useState} from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

import jwt from "jsonwebtoken";

const SidebarContent = props => {
  const [vehiclecount, setvehiclecount] = useState();
  const [editviolationlogs, seteditviolationlogs] = useState();
  const [registerdevice, setregisterdevice] = useState();
  const [registervehicle, setregistervehicle] = useState();
  const [smtp, setsmtp] = useState();
  const [challan, setchallan] = useState();
  const [usermanagement, setusermanagement] = useState();
  const [rolemanagement, setrolemanagement] = useState();

  const ref = useRef()
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
  const pathName = props.location.pathname;

  const decodedToken = jwt.decode(sessionStorage.getItem("Clear_AuthUser"));
  var UserPermissions=JSON.parse(decodedToken.userRolePermissions);

  // var UserPermissions=JSON.parse(sessionStorage.getItem("UserRolePermissions"));
 
  seteditviolationlogs(UserPermissions.EditViolations)
  setvehiclecount(UserPermissions.VehicleCount)
  setregisterdevice(UserPermissions.RegisterDevice)
  setregistervehicle(UserPermissions.RegisterVehicle)
  setsmtp(UserPermissions.SMTP)
  setchallan(UserPermissions.Challan)

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false
    }
    scrollElement(item);
    return false
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Main")} </li>
            <li>
              <Link to="/dashboard" className="waves-effect active">
                <i className="mdi mdi-view-dashboard"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>

            <li>
              <Link to="/Maps" className="waves-effect">
                <i className="mdi mdi-google-maps"></i>
                <span>{props.t("Maps")}</span>
              </Link>
              </li> 
             
            <li>
              <Link to="/ViolationLogs" className="waves-effect">
                <i className="mdi mdi-email-outline"></i>
                <span>{props.t("Violation Logs")}</span>
              </Link>
            </li>
   
            <li>
              <Link to="/ViolationsReport" className="waves-effect">
              <i className="mdi mdi-clipboard-outline"></i>
                <span>{props.t("Violation Reports")}</span>
              </Link>
            </li>
            {/* <li>
              <Link to="/#" className="waves-effect">
                <i className="mdi mdi-buffer"></i>
                <span>{props.t("User Management")}</span>
              </Link>
          
            </li> */}
    {vehiclecount &&   
     <li>
              <Link to="/VehicleCount" className="waves-effect">
              
              <i className="mdi mdi-google-analytics"></i>
                {/* <span className="badge rounded-pill bg-success float-end">6</span> */}
                <span>{props.t("Vehicle Count")}</span>
              </Link>
          
            </li>
 }
         
       

            <li>
              <Link to="/#" className="waves-effect">
                <span className="badge rounded-pill bg-danger float-end"></span>
                <i className="mdi mdi-saw-blade"></i>
                <span>{props.t("Settings")}</span>
              </Link>
            <ul className="sub-menu">
            {registerdevice &&  
                <li>
                  <Link to="/deviceManagementTabs">{props.t("Register Device")}</Link>
                </li>
               }
                {registervehicle &&  
                <li>
                  <Link to="/RegisterVehicle">{props.t("Register Vehicle")} </Link>
                </li>
                 }
                    {smtp &&  
                <li>
                  <Link to="/SMTPSettings">{props.t("Email And SMS")} </Link>
                </li>
                  }
                      {challan &&  
                <li>
                  <Link to="/ChallanSettings">{props.t("Challan")} </Link>
                </li>
                }
                 <li>
                  <Link to="/addZoneConfig">{props.t("Zone Configuration")} </Link>
                </li>
              </ul>
            </li>

              
              </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
